import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Faq } from '../../../../../../admin/src/app/models/faq';
import { FaqService } from '../../../../../../admin/src/app/services/faq.service';
import { Asset } from '../../../../../../admin/src/app/models/asset';
import { AuthService } from '../../../../../../admin/src/app/services/auth.service';
import { UserService } from '../../../../../../admin/src/app/services/user.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-product-faqs',
  templateUrl: './product-faqs.component.html',
  styleUrls: ['./product-faqs.component.css']
})
export class ProductFaqsComponent implements OnInit, OnDestroy {

  productId: string;

  faqs: Faq[];

  sub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private authSvc: AuthService,
    private faqSvc: FaqService,
    private userSvc: UserService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('Product faqs');

    this.sub = this.route.parent.paramMap.subscribe(params => {
      this.productId = params.get('productId');
      this.getFaqs();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getFaqs() {
    this.faqSvc.getAll(this.productId).subscribe(data => {
      this.faqs = Object.assign([], data.payload.elements);
      console.log(this.faqs);
    });
  }

  localizedFaqAsset(faq: Faq) {
    let lang = this.translate.currentLang;
    let defaultLang = this.translate.defaultLang;
    let content = faq.contents.find(c => c.lang === lang);
    if (!content || !content.asset) {
      content = faq.contents.find(c => c.lang === defaultLang);
    }
    return !!content ? content.asset : {};
  }

  localizedVideoUrl(faq: Faq) {
    let lang = this.translate.currentLang;
    let defaultLang = this.translate.defaultLang;
    let content = faq.contents.find(c => c.lang === lang);
    if (!content || !content.asset) {
      content = faq.contents.find(c => c.lang === defaultLang);
    }
    return !!content ? content.url : null;
  }

  safeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  isImage(asset: Asset) {
    return asset.type.indexOf('image') === 0;
  }

  isVideo(asset: Asset) {
    return asset.type.indexOf('video') === 0;
  }

  toggleFaq(faq) {
    faq.expanded = !faq.expanded;
  }

  isUserLoggedIn() {
    return !!this.authSvc.getCurrentToken();
  }

  hasLike(faq: Faq) {
    if (this.isUserLoggedIn()) {
      let user = this.userSvc.getUserInfo();
      return !!user && faq.likes.indexOf(user.id) !== -1;

    } else {
      return false;
    }
  }

  toggleLike(faq: Faq) {
    if (!this.hasLike(faq)) {
      this.faqSvc.addLike(faq.id).subscribe(data => {
        Object.assign(faq, data.payload);
      });
    } else {
      this.faqSvc.deleteLike(faq.id).subscribe(data => {
        Object.assign(faq, data.payload);
      });
    }
  }

}
